// extracted by css-extract-rspack-plugin
export default {"milestoneLink":"MilestoneMetadata-module__milestoneLink__BNWpK","milestoneTitleTruncate":"MilestoneMetadata-module__milestoneTitleTruncate__rzhDY"};